'use client'

import { ErrorView } from '@/features/errors/ErrorView'
import { captureError } from '../../instrumentation-client'
import { useEffect } from 'react'

export default function ErrorLayout({ error, reset }: { error: Error & { digest?: string }; reset: () => void }) {
  useEffect(() => {
    console.error(error)
    captureError(error)
  }, [error])

  return <ErrorView error={error} onReload={() => reset()} fullScreen />
}
